var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 7.04167C7.99577 7.04167 9.20833 5.8291 9.20833 4.33333C9.20833 2.83756 7.99577 1.625 6.5 1.625C5.00423 1.625 3.79167 2.83756 3.79167 4.33333C3.79167 5.8291 5.00423 7.04167 6.5 7.04167Z",
    stroke: "#030F1B",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8333 11.375C10.8333 10.2257 10.3768 9.12353 9.56413 8.31087C8.75147 7.49821 7.64927 7.04167 6.5 7.04167C5.35073 7.04167 4.24853 7.49821 3.43587 8.31087C2.62321 9.12353 2.16667 10.2257 2.16667 11.375",
    stroke: "#030F1B",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequested);
export default __webpack_public_path__ + "static/media/requested.cb204a49f40e13ac949fa0e1da96b634.svg";
export { ForwardRef as ReactComponent };